import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getEnv } from "../env";

export const useLanguage = () => {
  const settings = useSelector((state) => state.app.settings);
  const [language, setLanguage] = useState(
    settings?.language || getEnv("REACT_APP_DEFAULT_LANGUAGE")
  );

  useEffect(() => {
    if (language !== settings?.language) {
      if (settings.language) {
        setLanguage(settings.language);
      } else {
        setLanguage(getEnv("REACT_APP_DEFAULT_LANGUAGE"));
      }
    }
  }, [settings, language]);

  return language;
};
